import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=3b3d08e9&scoped=true&"
import script from "./Privileges.vue?vue&type=script&lang=js&"
export * from "./Privileges.vue?vue&type=script&lang=js&"
import style0 from "./Privileges.vue?vue&type=style&index=0&id=3b3d08e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d08e9",
  null
  
)

export default component.exports